module.exports = __webpack_public_path__ + "static/media/42k.4cc82258.webp";